import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import EsccRecipientsListUI from './EsccRecipientsListUI.js'

class EsccRecipientsListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      toEmails: [],
      newToEmail: '',
      errorList: null
    }
  }

  componentDidMount() {
    this.loadRecipients()
  }

  loadRecipients() {
    RestApiUtils.get(this.props.context, '/api/su/esccRecipients', (response) => {
      this.setState({
        toEmails: response.toEmails || [],
        errorList: response.errorList
      })
    })
  }

  onRefreshClick = () => {
    this.loadRecipients()
  }

  onNewToChange = (event) => {
    this.setState({ newToEmail: event.target.value })
  }

  onAddToClick = () => {
    this.addRecipient('to', this.state.newToEmail)
  }


addRecipient(listType, email) {
    if (!email || !email.trim()) return
    RestApiUtils.post(this.props.context, `/api/su/esccRecipients/${listType}/add`,
      (response) => {
        if (response.errorList && response.errorList.length > 0) {
          this.setState({ errorList: response.errorList })
        } else {
         this.setState({ newToEmail: '', errorList: null })
          this.loadRecipients()
        }
      },
      { email: email.trim() }
    )
  }

 onRemoveClick = (listType, email) => {
    RestApiUtils.post(this.props.context, `/api/su/esccRecipients/${listType}/remove`,
      (response) => {
        if (response.errorList && response.errorList.length > 0) {
          this.setState({ errorList: response.errorList })
        } else {
          this.setState({ errorList: null })
          this.loadRecipients()
        }
      },
      { email: email }
    )
  }

  render() {
    return (
         <EsccRecipientsListUI
        context={this.props.context}
        toEmails={this.state.toEmails}
        newToEmail={this.state.newToEmail}
        errorList={this.state.errorList}
        onRemoveClick={this.onRemoveClick}
        onNewToChange={this.onNewToChange}
        onAddToClick={this.onAddToClick}
      />
    )
  }
}

export default EsccRecipientsListSF